/**
 * 店舗の一覧ページのルートコンポーネント、組織ごとにコピーして拡張
 *
 * テンプレートはJinjaの以下と紐づく
 * templates/organizations/{...}/points.html > templates/default/points.html
 *
 * 特にカスタマイズが不要なら複製は不要
 */
import { defineComponent, onMounted } from 'vue'
import PointsService from "@/services/PointsService.ts"
import PointsPage from "@/organizations/_default/points"
import _Page from '@/services/Page'
import { overrideFetchPoints, overrideGetPointsUrl, overrideHeaderStyle} from './overrides'
import HorizontalFilter from "./HorizontalFilter.vue"

export default defineComponent({
  extends: PointsPage,
  components: { HorizontalFilter },
  setup(props, context) {
    overrideFetchPoints()
    overrideGetPointsUrl()
    

    const page = PointsPage.setup(props, context)
    const isInternal = storelocator.path.id == "internal"

    // 1ページ表示する数調整
    PointsService.pagination.limit = 40
    PointsService.pagination.useSeeMore = false

    // 絞り込みUIをヨコに変更するため、必要な絞り込み設定のみ抽出する
    const filter = [...storelocator.search_conditions[0].children, storelocator.search_conditions[1]]

    function resetFilter() {
      console.log("Reset filter called")
    }

    onMounted(() => {
      overrideHeaderStyle(isInternal)
    })

    return {
      ...page,
      filter,
      isInternal,
      resetFilter
    }
  }
})